import React, { useState } from "react";
// Removed: import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap CSS should be linked via a CDN in your HTML file for this environment.

// Custom CSS for hover effects and transitions (if not already in a global CSS file)
// You might need to add this to your main CSS file (e.g., src/App.css)
/*
.hover-effect:hover {
    background-color: #e9ecef !important; // Lighter grey on hover
    color: #495057 !important; // Darker text on hover
}

.transition-all {
    transition: all 0.3s ease-in-out;
}
*/

const departments = [
    { "name": "शोध केंद्र के बारे में", "id": "about" },
    { "name": "शोध परियोजनाएं", "id": "researchProjects" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "seminarsWorkshops" },
    { "name": "शोधार्थी", "id": "researchScholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const departmentContent = {
    "about": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>शोध केंद्र के बारे में</h5>
            <h6 className="mb-3 text-secondary">परिचय</h6>
            <p className="mb-2 text-justify">भारत सरकार द्वारा राष्ट्रीय शिक्षा नीति 2020 में भारतीय ज्ञान-परम्परा का शिक्षा के विभिन्न स्तरों पर समावेश की अनुशंसा की गई है। इसी उद्देश्य को ध्यान में रखते हुए महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल में 21 मार्च 2023 को विश्वविद्यालय के माननीय कुलपति प्रो. रमेश चन्द्र भारद्वाज की अध्यक्षता में भारतीय ज्ञान-परम्परा शोध एवं प्रशिक्षण केन्द्र की स्थापना की गई। इस अवसर पर मुख्य अतिथि के रूप में प्रो. सन्निधानं सुदर्शन शर्मा, निदेशक, अशोक सिंघल वैदिक शोध संस्थान, गुरुग्राम उपस्थित रहे।</p>
            <p className="mb-2 text-justify">विद्यार्थियों में भारतीय ज्ञान-परम्परा की समझ बढ़ाने एवं पाठ्यक्रम में इससे सम्बद्ध विषयों को लागू करना है ताकि युवा पीढ़ी का चरित्र निर्माण, व्यक्तित्व का समग्र विकास एवं भारतीय चिन्तन परक शोध हो सके। अतः इस शोध एवं प्रशिक्षण केन्द्र के द्वारा प्रारम्भिक दौर में व्यापक स्तर पर भारतीय ज्ञान-परम्परा के परिचय हेतु संगोष्ठी, परिसंवाद, कार्यशालाओं इत्यादि का आयोजन करना है। इनका विश्वविद्यालय में गत वर्षों में आयोजन किया भी गया है और भविष्य में भी निरन्तर करते रहने की योजना है।</p>
            <p className="mb-2 text-justify">विश्वविद्यालय के इस केन्द्र के द्वारा भारतीय ज्ञान परम्परा सम्बद्ध पाठ्यक्रम निर्माण किए भी गए हैं जिनमें से शास्त्री (बी.ए.) आचार्य (एम.ए.) के विद्यार्थियों के द्वारा ऐच्छिक विषय के रूप में पढ़े भी जा रहे हैं।</p>
            <p className="mb-2 text-justify">इस शोध एवं प्रशिक्षण केन्द्र के द्वारा अग्रिम योजना में भारतीय ज्ञान-परम्परा के परिचय हेतु प्रशिक्षण कार्यक्रम, प्रमाण-पत्रीय, क्रेडिट कोर्स, डिप्लोमा पाठ्यक्रम हेतु पाठ्यसामग्री निर्माण करना भी है।</p>
            <p className="mb-4 text-justify">भारतीय ज्ञान-परम्परा सम्बद्ध विषयों में शोध करने व विद्यार्थियों को शोध करवाने की योजना है।</p>

            <h6 className="mb-3 text-secondary">केन्द्र के उद्देश्य एवं कार्य</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान-परम्परा सम्बद्ध ज्ञान की समझ बढ़ाने हेतु विश्वविद्यालय में राष्ट्रीय व अन्तर्राष्ट्रीय स्तर पर सम्मेलन, संगोष्ठी, परिसंवाद एवं शिक्षण संस्थानों में प्रशिक्षण कार्यक्रम एवं कार्यशालाओं का आयोजन करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">विश्वविद्यालय एवं शिक्षण संस्थानों में प्रत्येक विषय की पाठ्यचर्या में उस विषय की भारतीय संकल्पना एवं इतिहास का ज्ञान प्रदान करने का प्रयत्न करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">पाठ्चर्या एवं पुस्तकों में भारतीय ज्ञान-परम्परा सम्बद्ध ज्ञान के समावेश हेतु भारतीय भाषाओं की शब्दावली का प्रयोग करना एवं भारतीय भाषाओं में अनुवाद की व्यवस्था करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">शिक्षणशास्त्र के भारतीय उपागमों के विकास हेतु भारतीय ज्ञान-परम्परा सम्बद्ध ज्ञान के श्रवण, मनन, निदिध्यासन इन पद्धतियों के प्रयोग करने की दिशा में कार्य करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">परीक्षा एवं मूल्यांकन के सम्बन्ध में सतत एवं समग्रता से मूल्यांकन करने की वैज्ञानिकता एवं भारतीय पद्धति विकसित करने का प्रयास करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान-परम्परा के विविध विषयों पर शोध एवं अनुसन्धान की व्यापक दृष्टि रखना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">व्यक्तिव एवं चरित्र निर्माण के समग्र विकास हेतु निरन्तर कार्य करना ताकि युवा पीढ़ी एक सशक्त राष्ट्र के निर्माण में अपना अमूल्य योगदान दे सके।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान-परम्परा सम्बद्ध ज्ञान की मूल भाषा संस्कृत के आधारभूत संरचना एवं संस्कृत लेखन-कौशल संवर्धन हेतु प्रशिक्षण कार्यक्रमों का आयोजन करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">विश्वविद्यालय एवं केन्द्र के पुस्तकालय में भारतीय ज्ञान-परम्परा सम्बद्ध ग्रन्थों की उपलब्धता सुनिश्चित करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान-परम्परा सम्बद्ध पाठ्क्रमों का निर्माण करना, पाठ्यक्रमों की विषय वस्तु का संग्रह करना एवं उन पाठ्यक्रमों को विश्वविद्यालय में लागू करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय भाषाओं में अनुवाद की व्यवस्था करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">निःस्वार्थ भाव से कार्य करने की क्षमता एवं प्रवृत्ति को विकसीत करने हेतु शिक्षा में सामाजिक कार्य के अनुभव को अनिवार्य करना व भारतीयता लाने की योजना पर कार्य करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">अध्यात्म एवं विज्ञान के समन्वय की राह पर निरन्तर कार्य करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">राष्ट्रीय शिक्षा नीति-2020 के प्रारुप के अनुसार अपने विश्वविद्यालय एवं अन्य शिक्षण संस्थानों में भारतीय ज्ञान-परम्परा के समावेश हेतु व्यापक कार्ययोजना एवं सतत प्रयास करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">कौशल विकास के सन्दर्भ में स्थानीय कला, कारीगरी, कौशल का शिक्षण में समावेश करके विद्यार्थियों को स्थानीय कृषि, उद्योग और व्यापार कौशल के योग्य बनाना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान-परम्परा सम्बद्ध शोध स्मारिकाओं, शोधपत्रों, शोध पत्रिकाओं एवं ग्रन्थों का प्रकाशन करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">सांस्कृतिक और धार्मिक जागरुकता उत्पन्न करना।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान-परम्परा सम्बद्ध विविध परियोजनाओं पर कार्य करना।</li>
            </ol>

            <h6 className="mb-3 text-secondary">भारतीय ज्ञान परम्परा सम्बद्ध विविध पाठ्यक्रमों का विवरण</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान परम्परा में खगोलीय भौतिक विज्ञान।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्ञान परम्परा में ग्रह गणित एवं पंचांग साधन।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय खगोल विद्या।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय भाषाओं का अन्त: सम्बन्ध।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय गणित का इतिहास।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">प्राचीन भारत में रसायन विज्ञान।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय राजनीतिक चिन्तन।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय ज्यामिति, रेखागणित एवं बीजगणित।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारत में प्रौद्योगिकी का इतिहास ऐतिहासिक परिप्रेक्ष्य में।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">भारतीय कालगणना एवं खगोल भौतिकी।</li>
            </ol>
        </div>
    ),
    "researchProjects": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>शोध परियोजनाएं</h5>
            <p className="text-muted text-justify">शोध परियोजनाओं की जानकारी जल्द ही उपलब्ध कराई जाएगी।</p>
            {/* You can add specific research project details here when available */}
        </div>
    ),
    "seminarsWorkshops": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>सेमीनार/सम्मेलन/कार्यशाला</h5>
            <h6 className="mb-3 text-secondary">शोध केन्द्र द्वारा आयोजित कार्यक्रम</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0 text-justify">20-21 मार्च 2023 को सूक्ष्मदिक्साधन एवं पञ्चाङ्ग मण्डन विषय पर द्विदिवसीय राष्ट्रीय कार्यशाला का आयोजन हुआ।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">14-16 अप्रैल 2023 को भारतीय ज्ञान-परम्परा सम्बद्ध पाठ्यक्रम निर्माण हेतु त्रिदिवसीय राष्ट्रीय कार्यशाला का आयोजन किया गया।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">05-07 मई 2025 को भारतीय ज्ञान-परम्परा राष्ट्रीय शिक्षा नीति 2020 के परिप्रेक्ष्य में त्रिदिवसीय राष्ट्रीय संगोष्ठी का आयोजन किया गया।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">24-30 जुलाई 2024 को संस्कृत भाषा की आधारभूत संरचना विषय पर सप्त दिवसीय प्रशिक्षण कार्यक्रम का आयोजन किया गया।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">24 अगस्त 2024 को भारतीय विधिशास्त्र एवं न्याय व्यवस्था विषय पर एक दिवसीय राष्ट्रीय कार्यशाला का आयोजन किया गया।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">21 सितम्बर 2024 को भारतीय विधिशास्त्र एवं न्याय व्यवस्था विषय पर पाठ्यक्रम निर्माण हेतु विशेषज्ञ विद्वानों की आनलाईन संगोष्ठी आयोजित की गई।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">दिनांक - 21 जनवरी से 30 जनवरी 2025 तक भारतीय ज्ञान परम्परा एवं बहुभाषावाद : राष्ट्रीय शिक्षा नीति 2020 अभिविन्यास एवं संवेदीकरण कार्यक्रम सीपीडीएचई दिल्ली विश्वविद्यालय एवं महर्षि वाल्मीकि संस्कृत विश्वविद्यालय कैथल के द्वारा आयोजन किया गया।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">07 से 09 फरवरी 2025 को प्रयागराज महाकुम्भ में शिक्षा संस्कृति उत्थान न्यास एवं केन्द्रीय संस्कृत विश्वविद्यालय दिल्ली द्वारा आयोजित ज्ञान-महाकुम्भ संगोष्ठी एवं सम्मेलन में विश्वविद्यालय के प्रतिनिधि के रूप में प्रतिभागिता करते हुए भारतीय ज्ञान परम्परा शोध एवं प्रशिक्षण केन्द्र के संयोजक डॉ. नवीन शर्मा द्वारा केन्द्र द्वारा किए गए कार्यों का प्रस्तुतीकरण किया गया।</li>
            </ol>
        </div>
    ),
    "researchScholars": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>शोधार्थी</h5>
            <p className="text-muted text-justify">वर्तमान में कोई शोधार्थी पंजीकृत नहीं है।</p>
            {/* Add actual research scholar details if available */}
        </div>
    ),
    "achievements": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>उपलब्धियां</h5>
            <h6 className="mb-3 text-secondary">प्रकाशित पुस्तकें:</h6>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0 text-justify">
                    भारतीय ज्ञान परम्परा शोध एवं प्रशिक्षण केन्द्र द्वारा **भारतीय ज्ञान परम्परा : विविध आयाम** पुस्तक का प्रकाशन किया गया, जिसके प्रधान सम्पादक - **प्रो. रमेश चन्द्र भारद्वाज** (पूर्व कुलपति, महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल), सम्पादक - **डॉ. नवीन शर्मा** (संयोजक, भारतीय ज्ञान परम्परा शोध एवं प्रशिक्षण केन्द्र) रहे। पुस्तक का विमोचन महामहिम राज्यपाल **श्री बण्डारु दत्तात्रेय जी** द्वारा 19 मार्च 2025 को विश्वविद्यालय के प्रथम दीक्षान्त समारोह में किया गया।
                </li>
            </ul>
        </div>
    ),
    "contact": (
        <div>
            <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>सम्पर्क</h5>

            {/* Academic Staff Contact */}
            <h6 className="mb-3 text-secondary">भारतीय ज्ञान परम्परा शोध एवं प्रशिक्षण केन्द्र में कार्यरत शैक्षणिक कर्मचारी</h6>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>कर्मचारी का नाम</th>
                            <th>पद</th>
                            <th>सम्पर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td><strong className="text-secondary">डॉ. नवीन शर्मा</strong> संयोजक (भारतीय ज्ञान-परम्परा शोध एवं प्रशिक्षण केन्द्र)</td>
                            <td>सहायक आचार्य (ज्योतिष विभाग)</td>
                            <td><a href="tel:+919650834736" className="text-decoration-none text-dark fw-bold">96508-34736</a></td>
                            <td><a href="mailto:Bktrtc@mvsu.ac.in" className="text-decoration-none text-dark fw-bold">Bktrtc@mvsu.ac.in</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>


            {/* Non-Academic Staff Contact */}
            <h6 className="mb-3 text-secondary">भारतीय ज्ञान परम्परा शोध एवं प्रशिक्षण केन्द्र में कार्यरत गैर-शैक्षणिक कर्मचारी</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>कर्मचारी का नाम</th>
                            <th>पद</th>
                            <th>सम्पर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री मुकेश कुमार</td>
                            <td>लिपिक (HKRN)</td>
                            <td><a href="tel:+919592123777" className="text-decoration-none text-dark fw-bold">9592-123-777</a></td>
                            <td><a href="mailto:Mukeshkaushik680@gmail.com" className="text-decoration-none text-dark fw-bold">Mukeshkaushik680@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default function IndianKnowledgeTraditionResearchTrainingCenter() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        setShowSidebar(false); // Hide sidebar on click for small screens
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>


            {/* Sidebar */}
            <aside className={` text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">भारतीय ज्ञानपरम्परा शोध एवं प्रशिक्षण केंद्र</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeContentId === dept.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined, // Apply purple when active
                            }}
                            onClick={() => handleItemClick(dept.id)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" onClick={() => setShowSidebar(false)}>
                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>
        </div>
    );
}